import React from 'react';

const Vardump = ({ data, title = "Vardump" }) => {
  return (
    <div style={{
      background: '#f5f5f5',
      padding: '10px',
      margin: '10px 0',
      border: '1px solid #ddd',
      borderRadius: '4px'
    }}>
      <strong>{title}:</strong>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

export default Vardump;